import { sanitizeCitationHtml } from 'js/citation_generator/sanitize';

const ENTITY_MAP: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  nbsp: ' ',
  apos: "'",
};

export function htmlToPlain(html: string): string {
  return html
    .replace(/<sup>(.*?)<\/sup>/gi, '$1')
    .replace(/<[^>]+>/g, '')
    .replace(/&([a-z]+);/gi, (_match, name: string) => {
      return ENTITY_MAP[name.toLowerCase()] ?? _match;
    })
    .replace(/&#(\d+);/g, (_match, code: string) => {
      return String.fromCharCode(Number(code));
    })
    .replace(/\s+/g, ' ')
    .trim();
}

export async function copyCitation(html: string): Promise<void> {
  const safeHtml = sanitizeCitationHtml(html);
  const plain = htmlToPlain(safeHtml);
  if (typeof ClipboardItem === 'function' && navigator.clipboard.write) {
    const item = new ClipboardItem({
      'text/plain': new Blob([plain], { type: 'text/plain' }),
      'text/html': new Blob([safeHtml], { type: 'text/html' }),
    });
    await navigator.clipboard.write([item]);
    return;
  }
  await navigator.clipboard.writeText(plain);
}
